import type { ReactNode } from "react";
import { StyleSheet, Text } from "react-native";

import { fonts, useThemedStyles, type ThemeColors } from "~/styles/theme";
import { AppText } from "./AppText";
import { Card } from "./Card";

export function MetricCard({
  label,
  value,
  hint,
  accent = "none",
  emphasis = false,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  accent?: "none" | "mint" | "danger";
  /** Render the value in the marigold accent — use for the single key number. */
  emphasis?: boolean;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <Card gap="sm" compact accent={accent}>
      <AppText size="xs" tone="muted">
        {label}
      </AppText>
      <Text
        style={[stylesheet.value, emphasis ? stylesheet.valueEmphasis : null]}
      >
        {value}
      </Text>
      {hint ? (
        <AppText size="xs" tone="muted">
          {hint}
        </AppText>
      ) : null}
    </Card>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    value: {
      color: colors.heading,
      fontFamily: fonts.bold,
      fontSize: 24,
      lineHeight: 28,
    },
    valueEmphasis: { color: colors.accent },
  });
